import { Box, styled } from '@mui/material';

const PREFIX = 'ConfirmationFinal';

export const classes = {
  circleContainer: `${PREFIX}-circleContainer`,
  deleteIcon: `${PREFIX}-deleteIcon`,
  textContainer: `${PREFIX}-textContainer`,
};

export const StyledBox = styled(Box)(({ theme }) => ({
  [`& .${classes.circleContainer}`]: {
    backgroundColor: theme.palette.error.light,
    marginBottom: theme.spacing(3),
    borderRadius: '50%',
    width: '80px',
    height: '80px',
  },

  [`& .${classes.deleteIcon}`]: {
    color: '#fff',
  },

  [`& .${classes.textContainer}`]: {
    textAlign: 'center',
    lineHeight: 2,
  },
}));